import { Skeleton } from '@/components/ui/skeleton';

/** Skeleton rows while a page loads; announced politely to screen readers. */
export function LoadingState({ rows = 5, label = 'Loading' }: { rows?: number; label?: string }) {
  return (
    <div role="status" aria-live="polite" className="flex flex-col gap-3">
      <span className="sr-only">{label}…</span>
      {Array.from({ length: rows }, (_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static placeholders
        <Skeleton key={i} className="h-12 w-full" />
      ))}
    </div>
  );
}
